import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from "@sentry/react";

import App from "./App";

import "./index.css";
import "./i18n/i18n";

// Sentry uniquement en production (VITE_IS_PRODUCTION=true au build, via .env.production)
const isProduction = import.meta.env.VITE_IS_PRODUCTION === 'true';

if (isProduction) {
  console.log('[Sentry] Init…', { environment: 'production' });
  Sentry.init({
    dsn: "https://09150f6e8b5b0fd4f22bc739da5dae43@o4510551948918784.ingest.de.sentry.io/4510551951999056",
    sendDefaultPii: true,
    environment: 'production',
    tracesSampleRate: 0.2,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
    ],
  });
  console.log('[Sentry] Initialized', { environment: 'production' });

  const originalConsoleError = console.error;
  console.error = (...args: unknown[]) => {
    if (args[0] instanceof Error) {
      Sentry.captureException(args[0]);
    } else {
      Sentry.captureMessage(`Console Error: ${args.map(String).join(' ')}`, 'error');
    }
    originalConsoleError.apply(console, args);
  };


}


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
        <Toaster
          position="bottom-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: "#363636",
              color: "#fff",
            },
          }}
        />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
